<!-- Modal Require Holidays -->
<ng-template #addAbsence let-modal>
    <div [formGroup]="formGroup">
        <div class="modal-header">
            <div></div>
            <button type="button" class="close" (click)="modalClose()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0">
            <h3>{{"ADD_ABSENCE_EMPLOYEE" | translate}}</h3>
            <div class="form-group mb-1">
                <label [for]="'type'">{{"TITLES.USERS_TYPES_SINGULAR.employee" | translate}}<sup class="text-danger">*</sup></label>
                <ng-select (change)="formGroup.patchValue({note: ''});" formControlName="user" id="user"
                           [bindLabel]="'complete_name'" [bindValue]="'hash'" [items]="usersList"
                           [searchable]="true" [closeOnSelect]="true" [clearable]="false"
                           [openOnEnter]="false" [virtualScroll]="true">
                </ng-select>
            </div>
            <div class="form-group mb-1">
                <label [for]="'type_absence'">{{"CATEGORY" | translate}}<sup class="text-danger">*</sup></label>
                <ng-select (change)="changeAbsenceTypesList();formGroup.patchValue({note: ''});" [(ngModel)]="categoryAbsence" id="type_absence"
                           [bindLabel]="'name'" [bindValue]="'name'"
                           [searchable]="true" [closeOnSelect]="true" [clearable]="false"
                           [items]="listTypesAbsence" [ngModelOptions]="{standalone: true}"
                           [openOnEnter]="false" [virtualScroll]="true">
                </ng-select>
            </div>
            <div class="form-group mb-1" *ngIf="categoryAbsence">
                <label [for]="'type'">{{"TYPE_HOLIDAY" | translate}}<sup class="text-danger">*</sup></label>
                <ng-select (change)="checkAdditionalInput(); formGroup.patchValue({note: ''});" formControlName="type" id="type"
                           [bindLabel]="'name'" [bindValue]="'id'"
                           [searchable]="true" [closeOnSelect]="true" [clearable]="false"
                           [items]="absenceTypesListFiltered"
                           [openOnEnter]="false" [virtualScroll]="true">
                </ng-select>
            </div>
            <div class="form-group mb-1" *ngIf="categoryAbsence">
                <label for="from">{{categoryAbsence && categoryAbsence === 'Permesso' ? ("DAY" | translate | titlecase) : ("FROM" | translate)}}<sup class="text-danger">*</sup></label>
                <ng2-flatpickr id="from" [ngClass]="'from'" [config]="basicDateOptions" formControlName="from">
                </ng2-flatpickr>
            </div>
            <div class="form-group mb-1" *ngIf="categoryAbsence && categoryAbsence !== 'Permesso'">
                <label for="to">{{"TO" | translate}}<sup class="text-danger">*</sup></label>
                <ng2-flatpickr id="to" [setDate]="formGroup.value.from" [ngClass]="'to'" [config]="basicDateOptions" formControlName="to">
                </ng2-flatpickr>
            </div>
            <div class="row" *ngIf="categoryAbsence && categoryAbsence === 'Permesso'">
                <div class="form-group col-md-6 mb-1">
                    <label for="hour_from">{{"HOUR_FROM" | translate}}<sup class="text-danger">*</sup></label>
                    <ngb-timepicker (change)="setHour()" id="hour_from" formControlName="hour_from" [spinners]="false"></ngb-timepicker>
                </div>
                <div class="form-group col-md-6 mb-1">
                    <label for="hour_to">{{"HOUR_TO" | translate}}<sup class="text-danger">*</sup></label>
                    <ngb-timepicker id="hour_to" formControlName="hour_to" [spinners]="false"></ngb-timepicker>
                </div>
            </div>
            <div *ngIf="requireNote" class="form-group mb-1">
                <label for="note">{{"NOTE" | translate}}<sup class="text-danger">*</sup></label>
                <textarea class="form-control" name="note" id="note" cols="45" rows="3" formControlName="note"></textarea>
            </div>
            <div *ngIf="requireFile" class="form-group mb-1">
                <fieldset>
                    <label for="file">{{'INSERT.UPLOAD_DOCUMENT' | translate}}</label>
                    <div class="custom-file">
                        <input class="custom-file-input" type="file" lang="it" id="file" accept="application/pdf" (change)="handlerChangeFileInput($event)"/>
                        <label *ngIf="!fileName" class="custom-file-label">{{"SELECT_FILE" | translate}}</label>
                        <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{fileName}}</label>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="modal-footer d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()" rippleEffect>{{"CANCEL" | translate}}</button>
            <button [disabled]="!formGroup.value.type && !formGroup.value.from && !formGroup.value.user" type="submit" (click)="sendAbsenceRequest()" class="btn btn-primary w-150" rippleEffect>
                {{"SEND" | translate}}
            </button>
        </div>
    </div>
</ng-template>
<!-- / Modal Require Holidays -->